module.exports = __webpack_public_path__ + "img/ill-home-aboutus-header.f868de93.svg";